var _g, _rect, _text, _g2, _path, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoiRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plus_Icon_Green"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 8,
    fill: "none",
    width: 21.1,
    height: 17.8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 15.27 21.6577)",
    fill: "#FFFFFF",
    fontFamily: "'TitilliumWeb-Bold'",
    fontSize: "19.5px"
  }, "!")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f22f1c",
    d: "M31.5,13.9C31.5,24.4,17.8,36,17.8,36S4.5,24.4,4.5,13.7C4.5,6.1,10.7-0.1,18.1,0S31.5,6.3,31.5,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18,0v1l0.1,0C25,1.1,30.5,6.9,30.5,13.9c0,8.6-10,18.3-12.7,20.7c-2.6-2.5-12.3-12.2-12.3-21 C5.5,6.7,11.1,1,18,1L18,0 M18,0C10.6,0,4.5,6.1,4.5,13.7C4.5,24.4,17.8,36,17.8,36s13.7-11.6,13.7-22.1c0-7.6-5.9-13.9-13.4-13.9 C18.1,0,18,0,18,0L18,0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18,19c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S20.8,19,18,19z M18,11c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3 S19.7,11,18,11z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Open_Down_Arrow_2_3_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Open_Down_Arrow_2_2_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Plus_Icon_POI_White"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Open_Down_Arrow_2"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Open_Down_Arrow_2_1_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Minus_Icon_POI_White"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Plus_Icon_POI_White_1_"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Minus_Icon_POI_White_1_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoiRed);
export default __webpack_public_path__ + "static/media/poi-red.a655454a49388e3757d6562d102798e4.svg";
export { ForwardRef as ReactComponent };